import React from 'react';
import {CircularProgress, Stack} from "@mui/material";

const LoadingInTheMiddle = () => {
    return (
        <Stack
            p={8}
            boxSizing="border-box"
            sx={{
                minHeight: '100%',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <CircularProgress/>
        </Stack>
    );
};

export default LoadingInTheMiddle;